import { ApiOperationBase } from 'api/rtk-api'
import { PresentationalTable } from 'components/core-v2'
import { Currency, formatCurrencyFull } from 'utilities/currency'

interface Props {
  operation: ApiOperationBase
}

export const ZCBTable = ({ operation }: Props) => {
  const rows = operation.cashTransactions
    .filter(x => x.instrumentType === 'ZcbCurve')
    .map(op => [
      op.instrumentId,
      new Date(op.maturityDate).toLocaleString(undefined, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }),
      new Date(op.createdDate).toLocaleString(undefined, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }),
      op.shares.toFixed(6),
      formatCurrencyFull(op.value, op.currency as Currency)
    ])
  return (
    <PresentationalTable
      headerRow={['ZCB Name', 'Maturity Date', 'Exe. Date', 'Units', 'Amount']}
      rowOptions={[
        { width: '35%' },
        { width: '25%' },
        { width: '15%' },
        { width: '10%', align: 'right' },
        { width: '15%', align: 'right' }
      ]}
      rows={rows}
    />
  )
}
